import { render, staticRenderFns } from "./AuthorRefPicker.vue?vue&type=template&id=5aa7325e&"
import script from "./AuthorRefPicker.vue?vue&type=script&lang=js&"
export * from "./AuthorRefPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports